import Axios from 'axios';

import { HttpStatusCodeEnum, ZepQuizApiError } from '@/api/httpClient';

const isApiErrorInErrorCodes = (error: unknown, httpCodes: number[]) => {
  if (error instanceof ZepQuizApiError) {
    return httpCodes.includes(error.httpStatus);
  }

  if (Axios.isAxiosError(error)) {
    return httpCodes.includes(error.response?.status || 200);
  }
};
export const isAuthenticationError = (error: unknown) =>
  isApiErrorInErrorCodes(error, [HttpStatusCodeEnum.UNAUTHORIZED_401]);

export const isCanceledError = (error: unknown) => Axios.isCancel(error);

// 취소 + 401/403 을 묶어 판별하는 공유 구현. 계약이 다른 소비자들이 각자
// 아래 목적별 래퍼를 쓰도록 해, 한 소비자의 요구로 이 판별을 바꿨다가 다른
// 소비자가 깨지는 사고를 막는다.
const isCanceledOrAuthError = (_error: unknown) => {
  if (Axios.isCancel(_error)) {
    return true;
  }

  return isApiErrorInErrorCodes(_error, [
    HttpStatusCodeEnum.UNAUTHORIZED_401,
    HttpStatusCodeEnum.FORBIDDEN_403,
  ]);
};

/**
 * 에러 바운더리에서 UI 를 띄우지 않고 조용히 넘길 에러인지 판별한다.
 * 취소/401/403 은 useApiError 전역 처리 경로가 담당하므로, 바운더리는
 * 폴백 UI 를 렌더하지 않고 리셋만 한다.
 */
export const isErrorBoundarySuppressedError = (_error: unknown) =>
  isCanceledOrAuthError(_error);

/**
 * 프로필 조회(useGetAuthProfile) 에서 바운더리로 던지지 않고 조용히 무시할
 * 에러인지 판별한다. 취소/401/403 은 비로그인·세션만료 등 정상 상태이므로
 * 에러로 승격하지 않는다.
 */
export const isAuthProfileIgnoredError = (_error: unknown) =>
  isCanceledOrAuthError(_error);

// 404 에러, 400 에러는 무시
export const isIgnoreRetryError = (_error: unknown) => {
  return isApiErrorInErrorCodes(_error, [
    HttpStatusCodeEnum.UNAUTHORIZED_401,
    HttpStatusCodeEnum.FORBIDDEN_403,
    HttpStatusCodeEnum.BAD_REQUEST_400,
    HttpStatusCodeEnum.NOT_FOUND_404,
    HttpStatusCodeEnum.CONFLICT_409,
    HttpStatusCodeEnum.TOO_MANY_REQUESTS_429,
    HttpStatusCodeEnum.INTERNAL_SERVER_ERROR_500,
  ]);
};

export const LONG_REQUEST_TIMEOUT = 5 * 60 * 1000;
